import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ScrollableContainer,
  TableContainer,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusDot,
  // TooltipContainer,
} from './TrainingList.styles';
import DotLegend from './Legend.component';
import CourseInfoForUser from './CourseInfo.component';
import ExportData from './CreateCsv.component';

const TrainingList = ({ employees = [], managers = [], courses = [] }) => {
  const [close, setClose] = useState(false);
  const [courseInfo, setCourseInfo] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [hoveredCourse, setHoveredCourse] = useState(null);

  const allUsers = [...managers, ...employees];

  const handleUserClick = (user, course) => {
    if (!user || !course) {
      console.log(close);
      return;
    }
    setCourseInfo({ user, course });
    setClose(false);
  };
  // console.log('Course info', courseInfo);

  // Filter users based on the search term
  const filteredUsers = allUsers.filter(
    (user) =>
      user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.lastName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <ScrollableContainer>
      {/* Components above the table */}
      <CourseInfoForUser
        user={courseInfo?.user}
        course={courseInfo?.course}
        setClose={setClose}
        setCourseInfo={setCourseInfo}
      />
      <ExportData allUsers={allUsers} courses={courses} />
      <DotLegend searchTerm={searchTerm} setSearchTerm={setSearchTerm} />

      {/* Table content */}
      <TableContainer>
        <Table>
          <thead>
            <TableRow>
              <TableHeader>User</TableHeader>
              {courses?.map((course) => (
                <TableHeader
                  key={course.courseId}
                  onMouseEnter={() => setHoveredCourse(course)}
                  onMouseLeave={() => setHoveredCourse(null)}
                >
                  {course.courseName}
                  {hoveredCourse === course && (
                    <div
                      style={{
                        position: 'absolute',
                        backgroundColor: '#333',
                        color: '#fff',
                        padding: '0.5rem',
                        borderRadius: '4px',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        whiteSpace: 'nowrap',
                        zIndex: 10,
                      }}
                    >
                      {`Expires In: ${course.expiryDate} years ` ||
                        'No expiry date'}
                    </div>
                  )}
                </TableHeader>
              ))}
            </TableRow>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <TableRow key={user._id}>
                <TableCell>{`${user?.firstName} ${user?.lastName}`}</TableCell>
                {courses.map((course) => {
                  const userCourse = user.courses?.find(
                    (userCourse) => userCourse.courseId === course._id
                  );

                  let status = 'empty';
                  if (userCourse) {
                    if (new Date(userCourse.expiryDate) < new Date()) {
                      status = 'expired';
                    } else if (!userCourse.complete) {
                      status = 'in-progress';
                    } else if (userCourse.complete) {
                      status = 'completed';
                    }
                  }

                  return (
                    <TableCell key={course.courseId}>
                      <StatusDot
                        style={{ margin: '0 auto' }}
                        status={status}
                        onClick={() => handleUserClick(user, userCourse)}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </ScrollableContainer>
  );
};

TrainingList.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      employeeId: PropTypes.string,
      employeeName: PropTypes.string,
      courses: PropTypes.arrayOf(
        PropTypes.shape({
          courseId: PropTypes.string,
          status: PropTypes.string,
        })
      ),
    })
  ),
  managers: PropTypes.arrayOf(
    PropTypes.shape({
      managerId: PropTypes.string,
      managerName: PropTypes.string,
      courses: PropTypes.arrayOf(
        PropTypes.shape({
          courseId: PropTypes.string,
          status: PropTypes.string,
        })
      ),
    })
  ),
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      courseId: PropTypes.string,
      courseName: PropTypes.string,
    })
  ),
};

export default TrainingList;
